<template>
  <el-scrollbar height="100%">
    <div class="account-security">
      <div class="ac-info">
        <div class="info-title">Account Information</div>
        <div class="info-content">
          <div class="info-content-item">
            <div class="label"> Registered Region </div>
            <div class="content">
              {{ accountInfo.loginInfo && accountInfo.loginInfo.countryName }}
            </div>
          </div>
          <div class="info-content-item">
            <div class="label">Email/Phone Number</div>
            <div class="content">
              {{ formData.account }}
            </div>
          </div>
        </div>
      </div>

      <div class="cancellation">
        <div class="title">Cancellation</div>
        <div class="cancel-content">
          <div class="left">
            <div class="top">Account Cancellation</div>
            <div class="bottom">No longer using your account?</div>
          </div>
          <div class="right-del">
            <el-button type="danger" plain @click="showDelTip = true">
              Apply for Deletion
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </el-scrollbar>

  <el-dialog modal-class="dialog-modal" v-model="show" width="42rem">
    <template #header>
      <div class="dialog-header">Delete Account</div>
    </template>
    <div class="dialog-container">
      <div class="del-tip">
        <div class="icon">!</div>
        <div class="tip">
          After the account is cancelled, the data cannot be recovered, so
          please be cautious
        </div>
      </div>
      <div class="del-form">
        <el-form ref="validateRef" label-position="top" :model="formData" :rules="rules">
          <el-form-item label="Account" prop="account">
            <el-input v-model="formData.account" disabled></el-input>
          </el-form-item>
          <div class="account-tip">
            We send a verification code to your account
            <span>{{ formData.account }}</span>, which is valid for 15 minutes.
          </div>
          <el-form-item required error="Enter verification code" label="Verification code" prop="code">
            <div class="veri-wrap">
              <el-input class="ver-input" :maxlength="6"  v-model="formData.code"></el-input>
              <el-button class="send-code" type="primary" @click="sendCode" :disabled="!isFirst">
                {{ isFirst ? "Send" : `Resend(${timeCounter})s` }}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <template #footer>
      <div v-loading="delLoading" class="dialog-footer">
        <el-button @click="show = false">Cancel</el-button>
        <el-button type="danger" @click="confirmDel">Delete</el-button>
      </div>
    </template>
  </el-dialog>


  <el-dialog modal-class="dialog-modal del-mention" v-model="showDelTip" width="42rem">
    <template #header>
      <div class="dialog-header">Delete Account</div>
    </template>
    <div class="dialog-container">
      <div class="top-mention">
        <img src="@/assets/imgs/mention.svg" alt="">
        Proceed with caution! After deleting the account, data cannot be restored.
      </div>
      <div class="mention-items">
        <div v-for="item in delMentions" :key="item.title" class="mention-item">
          <div class="title">
            {{ item.title }}
          </div>
          <div class="content">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="showDelTip = false">Cancel</el-button>
        <el-button class="my-warning" type="warning" @click="showDelTip = false; show = true">Apply for
          Deletion</el-button>
      </div>
    </template>
  </el-dialog>

  <!-- // 删除成功或者失败 -->
  <el-dialog modal-class="dialog-modal del-mention" v-model="showDelResult" width="42rem">
    <template #header>
      <div class="dialog-header">Delete Account</div>
    </template>
    <div class="dialog-container">
      <div v-if="delSuccess" class="del-success">
        <div class="top-mention">
          <img src="@/assets/imgs/mention-success.svg" alt="">
          Your account has been cancelled
        </div>
        <div style="padding-left: 24px;" class="content">Jumping to login page soon</div>
      </div>
      <div v-else class="del-fail">

        <div class="top-mention">
          <img src="@/assets/imgs/x.svg" alt="">
          Sorry, deleting account failed.
        </div>
        <div class="mention-items">
          <div class="mention-item">
            <div class="title">
              1.There are bound or shared devices under this account.
            </div>
            <div class="content">Please delete or remove device in Device Manager.</div>
          </div>
        </div>

      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="afterDel">Confirm</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ElMessage } from "element-plus";
import { inject, ref, reactive, onBeforeMount, watch, nextTick } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const $api = inject("$api");
const accountInfo = reactive({});

const showDelTip = ref(false)


const delMentions = [
  { title: '1.Information of account, ID, and third party authorization will be cleared.', content: 'Make sure that no bound device and shared device are in this account.' },
  { title: '2.The account is not involved in  open platform service.', content: 'Make sure the account is not activated or has deleted platform service.' },
  { title: '3.The account info with all products in  will be cleared.', content: 'All device alarm messages and records under this account will be cleared.' },
  { title: '4.All transaction records under this account will be cleared.', content: 'All personal orders will be cleared.\nMake sure all orders are completed without dispute.\nAfter deleting the account, refund from the order will automatically waived.' },
]

const showDelResult = ref(false)
const delSuccess = ref(false)
const validateRef = ref();

watch(() => showDelResult.value, (newValue, oldValue) => {
  if (!newValue) {
    if (delSuccess.value) {
      router.push('/')
    }
  }
})

const delLoading = ref(false)
async function confirmDel() {
  await validateRef.value.validate();
  delLoading.value = true
  const {
    loginInfo: { email, phone, areaCode },
  } = accountInfo;
  const { code } = formData;
  const params = {
    data: {
      type: email ? "email" : "phone",
      account: email ? email : phone,
      validCode: code,
    },
  };
  if (!email) {
    params.data.areaCode = areaCode;
  }

  const res = await $api.login.cancellation(params);
  if (res.data.code === 10000) {
    delSuccess.value = true
    showDelResult.value = true
    sessionStorage.removeItem('loginInfo')
  } else if (res.data.code === 12311) {
    // ElMessage.error(
    //   "Account cancellation failed: [There are devices bound or shared under the account]"
    // );
    delSuccess.value = false
    showDelResult.value = true
  } else {
    ElMessage.error(`Account cancellation failed. reason: ${res.data.desc || '--'}`);
  }
  delLoading.value = false
  show.value = false
}

function afterDel() {
  if (delSuccess.value) {
    router.push('/')
  } else {
    showDelResult.value = false
  }

}
onBeforeMount(() => {
  const temp = JSON.parse(sessionStorage.getItem("loginInfo"));
  formData.account =
    temp.loginInfo.email ||
    `+${temp.loginInfo.areaCode} ${temp.loginInfo.phone}`;
  for (const key in temp) {
    if (Object.hasOwnProperty.call(temp, key)) {
      const value = temp[key];
      accountInfo[key] = value;
    }
  }
});

const show = ref(false);
watch(
  () => show.value,
  (newValue) => {
    !newValue
      ? (formData.code = "")
      : nextTick(() => validateRef.value.clearValidate());
  }
);
const rules = {
  code: [{ required: true, message: "Enter verification code" }],
};
const formData = reactive({
  account: "unilynk@bccto.cc",
  code: "",
});

const isFirst = ref(true);
const timeCounter = ref(60);

let timer = null;
const sendValidLoading = ref(false);
async function sendCode() {
  sendValidLoading.value = true;
  isFirst.value = false;
  timeCounter.value = 60;
  timer = setInterval(() => {
    timeCounter.value--;
    if (timeCounter.value === 0) {
      isFirst.value = true;
      clearInterval(timer);
    }
  }, 1000);
  const {
    token,
    loginInfo: { email, phone, areaCode },
  } = accountInfo;
  const params = {
    data: {
      type: email ? "email" : "phone",
      account: email ? email : phone,
      usage: "AccountCancellation",
      // accessToken: token
    },
  };
  if (!email) {
    params.data.areaCode = areaCode;
  }

  const res = await $api.login.getValidateCode(params);
  if (res.data.code === 10000) {
    ElMessage.success("Verification code sent successfully");
  } else if (res.data.code === 15003) {
    ElMessage.error("Get Verification code too many times");
  }
  sendValidLoading.value = false;
}
</script>

<style lang="scss" scoped>
.account-security {
  padding: 2.4rem;

  .info-title,
  .title {
    color: rgb(29, 33, 41);
    font-family: Outfit;
    font-size: 1.6rem;
    margin-bottom: 2rem;
    font-weight: 600;
  }

  .ac-info {
    .info-content {
      .info-content-item {
        display: flex;
        line-height: 3.2rem;
        align-items: center;

        .label {
          color: rgb(134, 144, 156);
          font-family: Outfit;
          font-size: 1.4rem;
          font-weight: 400;
          line-height: 2.2rem;
          margin-right: 2.4rem;
          flex-basis: 20rem;
        }

        .content {
          color: rgb(78, 89, 105);
          font-family: Outfit;
          font-size: 1.4rem;
        }
      }
    }
  }

  .cancellation {
    margin-top: 2.4rem;
    margin-bottom: 2rem;

    .cancel-content {
      display: flex;
      align-items: flex-start;
      line-height: 3.2rem;

      .left {
        flex-basis: 20rem;
        margin-right: 2.4rem;

        .top {
          color: rgb(134, 144, 156);
          font-family: Outfit;
          font-size: 1.4rem;
          font-weight: 400;
        }

        .bottom {
          color: rgb(134, 144, 156);
          font-family: Outfit;
          font-size: 1.2rem;
          font-weight: 300;
        }
      }
    }
  }
}

.dialog-modal {
  .dialog-header {
    color: rgb(78, 89, 105);
    font-family: Outfit;
    font-size: 16px;
    font-weight: 600;
  }

  :global(.el-dialog) {
    padding: 24px;
  }

  .dialog-container {
    .del-tip {
      display: flex;
      margin-bottom: 1.2rem;

      .icon {
        flex-shrink: 0;
        color: rgb(255, 149, 0);
        width: 1.6rem;
        height: 1.6rem;
        border-radius: 100%;
        border: 1px solid rgb(255, 149, 0);
        text-align: center;
        line-height: 1.2rem;
        font-size: 1.2rem;
        transform: rotate(180deg) translateY(-4px);
        margin-right: 1.2rem;
      }

      .tip {
        color: rgb(29, 33, 41);
        font-family: Outfit;
        font-size: 14px;
        font-weight: 600;
      }
    }

    .del-form {
      .account-tip {
        transform: translateY(-12px);
        font-family: Outfit;
        font-size: 12px;
        font-weight: 400;
        color: rgb(134, 144, 156);

        span {
          color: rgb(65, 156, 252);
        }
      }

      .veri-wrap {
        display: flex;
        width: 100%;

        .ver-input {
          flex-grow: 1;
          margin-right: 1.2rem;
        }
      }
    }
  }
}

.del-mention {

  .top-mention {
    display: flex;

    // align-items: center;
    line-height: 22px;
    align-items: flex-start;
    font-size: 14px;
    font-family: Outfit;
    color: rgb(233, 70, 58);

    img {
      margin-right: 8px;
      margin-top: 4px;
    }
  }

  .mention-items {
    padding-left: 24px;
    margin-top: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;

    .mention-item {
      margin-bottom: 8px;

      .title {
        color: rgba(0, 0, 0, 0.9);
      }

      .content {
        color: rgb(119, 119, 119);
      }
    }
  }


  .del-success,
  .del-fail {
    .top-mention {
      color: rgb(29, 33, 41);
    }

    margin-bottom: 16px;

    .content {
      margin-top: 4px
    }
  }
}

.my-warning {
  background-color: rgb(242, 86, 69);
  border-color: rgb(242, 86, 69)
}
</style>
